import { format } from '../format';

/**
 * Returns suggested display name based on the user full name.
 * The suggestion is the first name and first initial of the last name.
 * Returns null in case there is no full name.
 * @param {string} fullName - The user full name
 * @returns {string} The suggested display name
 */
export const suggest = (fullName?: string) => {
    if (!fullName || fullName.length === 0) {
        return null;
    }

    // multiple spaces splitter for cases the full name has more than one space between two names
    const nameParts = fullName.split(/\s+/);

    if (nameParts.length < 2) {
        return null;
    }

    const [firstName, [lastNameFirstLetter]] = nameParts;
    return format(`${firstName} ${lastNameFirstLetter}`);
};
